import CXMApiClient from "../CXMApiClient";

function initialState() {
  return {
    ContactSearchResults: [],
    ContactSearchPagination: {
      pageTotal: 0,
      pageNumber: 0,
      totalRecords: 0
    },
    ContactSearchCurrentPage: 1,
    ContactSearchCurrentSize: 25,
    ContactResultsLoading: false,
    searchRequest: {}
  };
}

const state = initialState();

const actions = {
  getRecentlyViewedContacts: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/crm/contacts/recently_viewed_contacts",
          request
        )
        .then(response => {
          context.commit("updateContactSearchResults", response.data.data);
          context.commit(
            "updateContactSearchPagination",
            response.data.pageData
          );
          resolve(response ? response.data : []);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  updateContactSearchCurrentPage: function(context, data) {
    context.commit("updateContactSearchCurrentPage", data);
  },
  updateContactSearchCurrentSize: function(context, data) {
    context.commit("updateContactSearchCurrentSize", data);
  },
  UpdateContactResultsLoading: function(context, data) {
    context.commit("UpdateContactResultsLoading", data);
  },
  advancedSearchContacts: function(context, request) {
    return new Promise((resolve, reject) => {
      context.commit("updateContactSearchResults", null);

      context.dispatch("searchContacts", request)
        .then(response => {
          context.commit("updateContactSearchResults", response.data.data);
          context.commit(
            "updateContactSearchPagination",
            response.data.pageData
          );
          resolve(response ? response.data : []);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  searchContacts: function (context, request) {
    // Generic action used in multiple places
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      if(!request.accountId)  request.accountId = context.getters.User.ViewAccountID;
      client
        .ProcessRequest("post", "/crm/contacts/advanced_search", request, request.accountPlatformId ? [request.accountPlatformId] : [])
        .then(response => {          
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  clearPagination: function(context, data) {
    context.commit("updateContactSearchPagination", {
      pageTotal: 0,
      pageNumber: 1,
      totalRecords: 0
    });
  },
  updateSearchRequest: function(context, data) {
    context.commit("updateSearchRequest", data);
  }
};

const mutations = {
  updateContactSearchResults: function(state, data) {
    state.ContactSearchResults = data;
  },
  updateContactSearchPagination: function(state, data) {
    state.ContactSearchPagination = data;
    state.ContactSearchCurrentPage = data.pageNumber;
  },
  updateContactSearchCurrentPage: function(state, data) {
    state.ContactSearchCurrentPage = data;
  },
  updateContactSearchCurrentSize: function(state, data) {
    state.ContactSearchCurrentSize = data;
  },
  UpdateContactResultsLoading: function(state, data) {
    state.ContactResultsLoading = data;
  },
  updateSearchRequest: function(state, request) {
    state.searchRequest = request;
  }
};

const getters = {
  ContactSearchResults: function() {
    return state.ContactSearchResults;
  },
  ContactSearchPagination: function() {
    return state.ContactSearchPagination;
  },
  ContactSearchCurrentPage: function() {
    return state.ContactSearchCurrentPage;
  },
  ContactSearchCurrentSize: function() {
    return state.ContactSearchCurrentSize;
  },
  ContactResultsLoading: function() {
    return state.ContactResultsLoading;
  },
  searchRequest: function() {
    return state.searchRequest;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/ContactSearch.js